<!--==============================
=            ERROR404            =
===============================-->

<template>
  <main class="transparent">
    <v-parallax dark height="900" src="../../assets/images/theme.jpg">
  <v-card flat class="ma-10 card-light" height="1000" :rounded="rounded">

    <v-toolbar color="primary" dark height="300" extended flat>

    </v-toolbar>

    <v-card :rounded="rounded" class="mx-auto transparent elevation-0 " outlined max-width="600" height="300"
      style="margin-top: -164px;">

      <div class="hit-the-floor">404</div>
      <v-row align="center" justify="center">
       
          <h1 class="text-h5 font-weight-medium primary--text mb-4">
            Sorry, an error has occured, Requested Page not found!
          </h1>
          <h4 class="subheading">
            <v-btn @click="home()" outlined  class="ma-2" rounded color="primary" dark>
          HOME
            </v-btn>
              <v-btn @click="dashboard()" outlined class="ma-2" rounded color="primary" dark>
            DASHBOARD
            </v-btn>
          </h4>
        
      </v-row>

    </v-card>
  </v-card>
</v-parallax>
</main>
</template>

<script>
  export default {

    data: () => ({
      rounded:'lg',
      loading: false,
      drawer: null,
      model: {
        username: "admin@admin.com",
        password: "password"
      }
    }),

    methods: {
      home() {
        this.loading = true;
        setTimeout(() => {
          this.$router.push("/");
        }, 1000);
      },
      dashboard() {
        this.loading = true;
        setTimeout(() => {
          this.$router.push("/dashboard/dashboard1");
        }, 1000);
      },
     
    }
  };
</script>
<style scoped>
  .hit-the-floor {
    color: #fff;
    font-size: 12em;
    font-weight: bold;
    font-family: Helvetica;
    text-shadow:
      0 1px 0 #ccc,
      0 2px 0 #c9c9c9,
      0 3px 0 #bbb,
      0 4px 0 #b9b9b9,
      0 5px 0 #aaa,
      0 6px 1px rgba(0, 0, 0, .1),
      0 0 5px rgba(0, 0, 0, .1),
      0 1px 3px rgba(0, 0, 0, .3),
      0 3px 5px rgba(0, 0, 0, .2),
      0 5px 10px rgba(0, 0, 0, .25),
      0 10px 10px rgba(0, 0, 0, .2),
      0 20px 20px rgba(0, 0, 0, .15);
  }

  .hit-the-floor {
    text-align: center;
  }
</style>



<!--====  End of ERROR404  ====-->